t = require('app/scripts/views/internal/teacup-with-helpers')('dialog_close_button')

module.exports = ->
  t.a '.icon-lg.icon-close.dialog-close-button.js-close-window', { href: '#' }
